import { LoadingOutlined } from '@ant-design/icons';

export default LoadingOutlined;
